import React, { useState } from "react";
import {CardBody, CardHeader, Modal, Form} from "react-bootstrap";
import ReactJson from "react-json-view";

const MonetizationView = ({show, onClose, monetization}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filterJson = (data) => {
    if (!searchTerm || !data) return data;
    
    const searchLower = searchTerm.toLowerCase();
    
    const filterObject = (obj, depth = 0) => {
      if (!obj || typeof obj !== 'object' || depth > 2) return obj;
      
      const filtered = {};
      let hasMatch = false;
      
      // First pass: check if any value in this object matches
      for (const [key, value] of Object.entries(obj)) {
        if (key.toLowerCase().includes(searchLower) || 
            (typeof value === 'string' && value.toLowerCase().includes(searchLower))) {
          hasMatch = true;
          break;
        } else if (value && typeof value === 'object') {
          const nestedMatch = checkNestedMatch(value, depth + 1);
          if (nestedMatch) {
            hasMatch = true;
            break;
          }
        }
      }
      
      // If this object has a match, include all its properties
      if (hasMatch) {
        for (const [key, value] of Object.entries(obj)) {
          if (value && typeof value === 'object') {
            filtered[key] = filterObject(value, depth + 1);
          } else {
            filtered[key] = value;
          }
        }
      }
      
      return filtered;
    };
    
    const checkNestedMatch = (obj, depth = 0) => {
      if (!obj || typeof obj !== 'object' || depth > 2) return false;
      
      for (const [key, value] of Object.entries(obj)) {
        if (key.toLowerCase().includes(searchLower) || 
            (typeof value === 'string' && value.toLowerCase().includes(searchLower))) {
          return true;
        } else if (value && typeof value === 'object') {
          if (checkNestedMatch(value, depth + 1)) {
            return true;
          }
        }
      }
      return false;
    };

    return filterObject(data);
  };

  return (
    <Modal show={show} onHide={onClose} size={"lg"}>
      <CardHeader>
        View Monetization: {monetization?.id}
      </CardHeader>
      <CardBody>
        <h3>Platform: {monetization?.platform}</h3>
        <h3>Env: {monetization?.environment}</h3>

        <Form.Group className="mb-3">
          <Form.Label>Search in JSON:</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter search term..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Form.Group>

        <label>Content: </label>
        <ReactJson
          src={filterJson(monetization?.content)}
          collapsed={false}
          enableClipboard={false}
          displayDataTypes={true}
          quotesOnKeys={false}
        />
      </CardBody>
    </Modal>
  );
};

export default MonetizationView;